// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUTOMATIC_COMMENT_VIOLATES_RULES = "Nahlas nevhodnou odpov\u011bd";
export const BLOCK_ANONYMOUS_USER = "Zablokovat anonyma";
export const BLOCK_USER = "Zablokovat u\u017eivatele";
export const CANCEL_EXCLUSION_FROM_DISCUSSION = "Zru\u0161 vylou\u010den\u00ed z diskuze";
export const DELETE = "Vyma\u017e";
export const EXCLUDE_FROM_DISCUSSION = "Vylou\u010d z t\u00e9to diskuze";
export const FORUM_COMMENT_EDIT_MENU = "Uprav";
export const FORUM_COMMENT_MOVE_UP = "Posunout odpov\u011b\u010f nahoru";
export const SEND_HEART_TO_username = "Po\u0161li srd\u00ed\u010dko %(username)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017eivatelky, kter\u00fdm se to l\u00edb\u00ed";
export const UNBLOCK_USER = "Odblokovat u\u017eivatele";
